/* CUSTOM coffee-brew — Espresso/Filter-Umschalter + tap-to-run Timer-Ring.
   Der Ring fuellt sich von 0 bis zur Ziel-Zeit (data-seconds des aktiven Panels). */
(function () {
  class CoffeeBrew extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-mode]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.ring = this.querySelector('[data-ring]');
      this.clock = this.querySelector('[data-clock]');
      this.startBtn = this.querySelector('[data-start]');
      this.circ = 2 * Math.PI * 54;
      if (this.ring) { this.ring.style.strokeDasharray = this.circ; this.ring.style.strokeDashoffset = this.circ; }
      this.tabs.forEach((t) => t.addEventListener('click', () => this.select(t.dataset.mode)));
      if (this.startBtn) this.startBtn.addEventListener('click', () => this.toggle());
      this.mode = this.tabs.length ? this.tabs[0].dataset.mode : null;
      this.select(this.mode);
    }
    select(mode) {
      if (!mode) return;
      this.mode = mode;
      this.tabs.forEach((t) => {
        const on = t.dataset.mode === mode;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => { p.hidden = p.dataset.panel !== mode; });
      this.reset();
    }
    panel() { return this.panels.find((p) => p.dataset.panel === this.mode); }
    target() { const p = this.panel(); return Math.max(1, parseInt((p && p.dataset.seconds) || '30', 10)); }
    toggle() { this.running ? this.stop() : this.start(); }
    start() {
      this.running = true;
      this.classList.add('is-running'); this.classList.remove('is-done');
      if (this.startBtn) this.startBtn.textContent = 'Stop';
      this.t0 = performance.now() - (this.elapsed || 0) * 1000;
      const tick = (now) => {
        if (!this.running) return;
        this.elapsed = (now - this.t0) / 1000;
        this.render();
        this.raf = requestAnimationFrame(tick);
      };
      this.raf = requestAnimationFrame(tick);
    }
    stop() {
      this.running = false;
      this.classList.remove('is-running');
      if (this.startBtn) this.startBtn.textContent = 'Resume';
      cancelAnimationFrame(this.raf);
    }
    reset() {
      this.running = false; this.elapsed = 0;
      cancelAnimationFrame(this.raf);
      this.classList.remove('is-running', 'is-done');
      if (this.startBtn) this.startBtn.textContent = 'Start';
      this.render();
    }
    render() {
      const tgt = this.target();
      const e = this.elapsed || 0;
      const prog = Math.min(e / tgt, 1);
      if (this.ring) this.ring.style.strokeDashoffset = this.circ * (1 - prog);
      const s = Math.floor(e), m = Math.floor(s / 60), ss = String(s % 60).padStart(2, '0');
      if (this.clock) this.clock.textContent = m + ':' + ss;
      if (prog >= 1 && this.running) {
        this.running = false;
        cancelAnimationFrame(this.raf);
        this.classList.add('is-done'); this.classList.remove('is-running');
        if (this.startBtn) this.startBtn.textContent = 'Done';
      }
    }
  }
  if (!customElements.get('coffee-brew')) customElements.define('coffee-brew', CoffeeBrew);
})();
